var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0B966B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.906 14.786v2.571H.656v-2.571M20.344 14.786v2.571h-5.25v-2.571M.656 8.357h19.688v6.429H.656z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0B966B",
    fillRule: "nonzero",
    cx: 3.938,
    cy: 11.571,
    rx: 1.313,
    ry: 1.286
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0B966B",
    fillRule: "nonzero",
    cx: 17.063,
    cy: 11.571,
    rx: 1.313,
    ry: 1.286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.656 8.357l2.326-6.835a1.31 1.31 0 011.246-.88h12.544a1.31 1.31 0 011.246.88l2.326 6.835",
    stroke: "#0B966B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconCar;